import { ACTION_TYPES } from './actions'

/**
 * Bottom resource cards. Each link has an icon on a tinted tile; `track` keeps
 * the Amplitude events the old knowledge-base rail sent (source:
 * 'knowledge_base'). Links without `track` send nothing, as before.
 */
export const RESOURCE_GROUPS = [
  {
    id: 'knowledge_base',
    title: 'Knowledge base',
    links: [
      {
        id: 'landing_page',
        label: 'Customizing the landing page',
        icon: 'tabler:layout-navbar',
        tint: '#FDE8E8',
        color: '#C9383B',
        action: { type: ACTION_TYPES.INTERCOM_ARTICLE, articleId: '11137803' },
      },
      {
        id: 'custom_domain',
        label: 'Customizing links with a custom domain',
        icon: 'tabler:link',
        tint: '#E9F1FF',
        color: '#015FFB',
        action: { type: ACTION_TYPES.INTERCOM_ARTICLE, articleId: '7864258' },
      },
      {
        id: 'ai_credits',
        label: 'How do the AI credits work?',
        icon: 'tabler:sparkles',
        tint: '#F0E9FF',
        color: '#7A4DFF',
        action: { type: ACTION_TYPES.INTERCOM_ARTICLE, articleId: '7863816' },
      },
    ],
    footerLink: {
      id: 'more_resources',
      label: 'More resources',
      action: { type: ACTION_TYPES.INTERCOM_SPACE, space: 'help' },
      track: { event: 'clicked_more_resources' },
    },
  },
  {
    id: 'stay_in_touch',
    title: 'Stay in touch',
    links: [
      {
        id: 'whats_new',
        label: "What's new: latest product updates",
        icon: 'tabler:news',
        tint: '#FFF6D7',
        color: '#B06E01',
        action: {
          type: ACTION_TYPES.EXTERNAL,
          href: 'https://mcg.noticeable.news',
        },
        track: {
          event: 'clicked_whats_new',
          props: { link_title: "What's new" },
        },
      },
      {
        id: 'youtube',
        label: 'Video guides on YouTube',
        icon: 'logos:youtube-icon',
        tint: '#FDE8E8',
        action: {
          type: ACTION_TYPES.EXTERNAL,
          href: 'https://www.youtube.com/@MiniCourseGeneratorWithAI',
        },
        track: {
          event: 'clicked_social_link',
          props: { platform: 'Learn with our video guides' },
        },
      },
      {
        id: 'linkedin',
        label: 'Community on LinkedIn',
        icon: 'logos:linkedin-icon',
        tint: '#E9F1FF',
        action: {
          type: ACTION_TYPES.EXTERNAL,
          href: 'https://www.linkedin.com/company/mini-course-generator/',
        },
        track: {
          event: 'clicked_social_link',
          props: { platform: 'Stay connected with our community' },
        },
      },
    ],
    footerLink: {
      id: 'send_feedback',
      label: 'Send feedback',
      action: { type: ACTION_TYPES.INTERCOM_MESSAGES },
      track: { event: 'clicked_intercom' },
    },
  },
]
